<!--课程学习记录-->
<template>
  <div
    class="hbn-container"
    id="userInfo"
    v-loading="loading"
    element-loading-text="文件导出中..."
    element-loading-background="rgba(122, 122, 122, 0.8)"
  >
    <div class="search-form">
      <el-row :gutter="24">
        <el-col :span="20">
          <el-form
            ref="form"
            :model="form"
            label-width="80px"
            label-position="right"
            size="mini"
          >
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="姓名">
                  <el-input
                    id="Name"
                    v-model="PageQuery.queryModel.name"
                    placeholder="姓名"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="课时">
                  <el-input-number
                    v-model="PageQuery.queryModel.classHour"
                    placeholder="课时"
                    :max="99999999"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="手机号">
                  <el-input
                    id="Name"
                    v-model="PageQuery.queryModel.phone"
                    placeholder="手机号"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-show="show" :gutter="24">
              <el-col :span="12">
                <el-form-item label="省-市-区">
                  <el-select
                    style="width: 33.33%"
                    v-model="SelectData.provinceId"
                    filterable
                    placeholder="请选择省"
                    @change="ProvinceChange"
                  >
                    <el-option
                      v-for="item in ProvinceList"
                      :key="item.id"
                      :label="item.areaName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>

                  <el-select
                    style="width: 33.33%"
                    v-model="SelectData.cityId"
                    filterable
                    placeholder="请选择市"
                    @change="CityChange"
                  >
                    <el-option
                      v-for="item in CityList"
                      :key="item.id"
                      :label="item.areaName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    style="width: 33.33%"
                    v-model="SelectData.regionId"
                    placeholder="请选择区"
                    filterable
                  >
                    <el-option
                      v-for="item in RegionList"
                      :key="item.id"
                      :label="item.areaName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态">
                  <el-select
                    v-model="PageQuery.queryModel.status"
                    placeholder="状态"
                  >
                    <el-option label="全部" :value="-1"> </el-option>
                    <el-option label="已创建" :value="0"> </el-option>
                    <el-option label="已审核" :value="1"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="岗位角色">
                  <el-select
                    v-model="PageQuery.queryModel.station"
                    filterable
                    placeholder="岗位角色"
                  >
                    <el-option
                      v-for="item in stationList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="4">
          <el-form-item>
            <el-button size="mini" class="hbn-button-serach" @click="seach"
              >查找</el-button
            >
            <span class="control-collapse" @click="show = !show">{{
              show ? "收起" : "展开"
            }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </div>

    <div class="hbn-table-screen">
      <div class="operation">
        <el-popconfirm title="是否要批量审核?" @confirm="onBatchAudit">
          <template #reference>
            <el-button type="primary" class="custom-button">
              <el-icon style="margin-right: 3px"> <promotion /> </el-icon
              >批量审核
            </el-button>
          </template>
        </el-popconfirm>

        <el-button type="primary" class="custom-button" @click="exportExcel">
          <i class="el-icon-download custom-icon"></i>
          <span>导出</span>
        </el-button>
      </div>

      <div class="custom-table-layer">
        <div style="margin-bottom: 13px">
          <vxe-table
            :data="DataList"
            :checkbox-config="tableCheckboxConfig"
            round
            border
            height="388"
            class="mytable-scrollbar"
            style="width: 100%"
            :highlight-current-row="true"
            @current-change="handleCurrentChange"
            @checkbox-change="handleSelectionChange"
            @checkbox-all="selectAllChangeEvent"
            ref="multipleTable"
            highlight-hover-row
            highlight-hover-column
            highlight-current-column
            show-overflow="tooltip"
            empty-text="没有更多数据了！"
            resizable
            stripe
          >
            <vxe-table-column
              fixed="left"
              type="checkbox"
              field="tableCheck"
              width="40"
            ></vxe-table-column>
            <vxe-table-column
              fixed="left"
              type="seq"
              width="55"
              title="序号"
              align="center"
            ></vxe-table-column>

            <template v-for="(item, key) in UnitList" :key="key">
              <vxe-table-column
                :field="item.prop"
                :title="item.label"
                :width="item.width"
                align="center"
                v-if="item.isShow"
                show-overflow-tooltip
              />
            </template>
            <vxe-table-column
              width="100"
              fixed="right"
              title="操作"
              align="center"
            >
              <template #default="{ row, rowIndex }">
                <div v-if="row.stausTxt === '已创建'">
                  <el-popconfirm
                    title="是否要审核?"
                    @confirm="onColumnClick(row, rowIndex, 1)"
                  >
                    <template #reference>
                      <el-button size="small" type="text">审核</el-button>
                    </template>
                  </el-popconfirm>
                  <el-popconfirm
                    title="是否要删除?"
                    @confirm="onColumnClick(row, rowIndex, 2)"
                  >
                    <template #reference>
                      <el-button size="small" type="text">删除</el-button>
                    </template>
                  </el-popconfirm>
                </div>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>

        <div class="pagination">
          <vxe-pager
            perfect
            size="mini"
            :current-page="PageQuery.pageindex"
            :page-size="PageQuery.PageSize"
            :page-sizes="[20, 50, 100, 500]"
            :total="total"
            :pager-count="5"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'NextJump',
              'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange"
          >
          </vxe-pager>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Search } from "@element-plus/icons";
import { CourseCertificateList } from "@/assets/apiData/CourseCertificate";
import {
  GetDataCourseCertificateList,
  DeleteDataCourseCertificate,
  BatchAuditDataCourseCertificate,
  ExportDataCourseCertificate,
} from "@api/ApiCourseCertificate";
import { GetUserPosts } from "@api/Company/ApiUser";
import excel from "@comp/ExcelHelper/importExcel";
import Enumerable from "linq";
import { ProvinceList } from "@/assets/apiData/Province";
import { ElMessage } from "element-plus";
export default {
  data() {
    return {
      PageQuery: {
        queryModel: {
          name: "",
          phone: "",
          status: -1,
          classHour: "",
          station: "",
        },
        pageindex: 1,
        PageSize: 20,
      },
      total: 0,
      show: false,
      UnitList: [],
      DataList: [],
      loading: false,
      ProvinceList: [],
      CityList: [],
      RegionList: [],
      SelectData: {
        provinceId: "",
        cityId: "",
        regionId: "",
      },
      stationList: [
        {
          id: "",
          name: "全部",
        },
        // {
        //   id: "分管负责人及专职安全管理人员",
        //   name: "分管负责人及专职安全管理人员",
        // },
        // {
        //   id: "班组长(含车间主任)",
        //   name: "班组长(含车间主任)",
        // },
        // {
        //   id: "重大危险源包保责任人",
        //   name: "重大危险源包保责任人",
        // },
      ],
      multipleSelection: [],
      tableCheckboxConfig: {
        checkMethod: ({ row }) => {
          return row.stausTxt === "已创建";
        },
      },
    };
  },
  components: {
    excel,
    Search,
  },
  methods: {
    getRoleList(){
      GetUserPosts().then(res=>{
        let list = (res || []).map(item=>{
          return {
            id:item.postName,
            name:item.postName
          }
        });
        this.stationList = [{
          id: "",
          name: "全部",
        }];
        this.stationList.push(...list)
      })
    },
    ProvinceChange() {
      this.SelectData.cityId = "";
      this.SelectData.regionId = "";
      this.ProvinceList.map((x) => {
        if (x.id == this.SelectData.provinceId) {
          this.CityList = JSON.parse(
            JSON.stringify(x.children.filter((o) => o.level == 3))
          );
          this.CityList.unshift({
            areaName: "-请选择-",
            id: "",
          });
        }
      });
    },
    CityChange() {
      this.SelectData.regionId = "";
      this.ProvinceList.map((x) => {
        if (x.id == this.SelectData.provinceId) {
          var cityId = this.SelectData.cityId;
          var parentCode = this.getCodeById(cityId);
          this.RegionList = JSON.parse(
            JSON.stringify(
              x.children.filter(
                (o) => o.level == 4 && o.parentCode == parentCode
              )
            )
          );
          this.RegionList.unshift({
            areaName: "-请选择-",
            id: "",
          });
        }
      });
    },
    getCodeById(id) {
      var code = "";
      this.ProvinceList.map((x) => {
        if (x.id == this.SelectData.provinceId) {
          x.children.forEach((o) => {
            if (o.id == id) {
              code = o.code;
              return;
            }
          });
        }
      });
      return code;
    },
    exportExcel() {
      this.loading = true;
      try {
        // 构建符合 API 文档的查询参数（参数名首字母大写）
        const queryParams = {};
        
        // 用户姓名
        if (this.PageQuery.queryModel.name) {
          queryParams.Name = this.PageQuery.queryModel.name;
        }
        // 手机号
        if (this.PageQuery.queryModel.phone) {
          queryParams.Phone = this.PageQuery.queryModel.phone;
        }
        // 状态
        if (this.PageQuery.queryModel.status !== undefined && this.PageQuery.queryModel.status !== null && this.PageQuery.queryModel.status !== '') {
          queryParams.Status = this.PageQuery.queryModel.status;
        }
        // 课时
        if (this.PageQuery.queryModel.classHour !== undefined && this.PageQuery.queryModel.classHour !== null && this.PageQuery.queryModel.classHour !== '') {
          queryParams.ClassHour = this.PageQuery.queryModel.classHour;
        }
        // 岗位角色
        if (this.PageQuery.queryModel.station) {
          queryParams.Station = this.PageQuery.queryModel.station;
        }
        // 省
        if (this.SelectData.provinceId) {
          queryParams.ProvinceId = this.SelectData.provinceId;
        }
        // 市
        if (this.SelectData.cityId) {
          queryParams.CityId = this.SelectData.cityId;
        }
        // 区
        if (this.SelectData.regionId) {
          queryParams.RegionId = this.SelectData.regionId;
        }
        
        ExportDataCourseCertificate(queryParams).then((result) => {
          this.loading = false;
        });
      } catch (e) {
        this.loading = false;
        console.log(e);
      }
    },
    seach() {
      this.PageQuery.pageindex = 1;
      this.GetData();
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.pageindex = 1; //说明更改了每页展示条数，要从第一页进行展示
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.pageindex = currentPage;
      }
      this.GetData();
    },
    handleCurrentChange(val) {
      console.log(val);
      this.GetData();
    },
    GetData() {
      this.PageQuery.queryModel = {
        ...this.PageQuery.queryModel,
        ...this.SelectData,
      };
      const _this = this;
      try {
        GetDataCourseCertificateList(_this.PageQuery).then(function (data) {
          _this.DataList = data.entities;
          _this.total = data.totalCount;
        });
      } catch (e) {
        console.log(e);
      }
    },
    //选中数量
    selectAllChangeEvent({ checked, records }) {
      this.multipleSelection = records;
    },
    handleSelectionChange({ records }) {
      this.multipleSelection = records;
    },
    onBatchAudit() {
      if (!this.multipleSelection.length) {
        return ElMessage.warning("请选择数据");
      }
      this.BatchAudit();
    },
    // type 1:审核  2:删除
    onColumnClick(data, index, type) {
      switch (type) {
        case 1:
          this.BatchAudit(data);
          break;
        case 2:
          this.Delete(data);
          break;
        default:
          break;
      }
    },
    // 删除
    Delete(data) {
      DeleteDataCourseCertificate([data.no])
        .then((res) => {
          ElMessage.success("删除成功");
          this.GetData();
        })
        .catch((err) => {
          ElMessage.error(err);
        });
    },
    // 审核or批量审核
    BatchAudit(data) {
      BatchAuditDataCourseCertificate(
        data ? [data.no] : this.multipleSelection.map((item) => item.no)
      )
        .then((res) => {
          ElMessage.success("审核成功");
          this.GetData();
        })
        .catch((err) => {
          ElMessage.error(err);
        });
    },
  },
  created() {
    this.ProvinceList = JSON.parse(JSON.stringify(ProvinceList.entities));
    this.ProvinceList.unshift({
      areaName: "-请选择-",
      code: "",
    });
    this.UnitList = CourseCertificateList;
    this.GetData();
    this.getRoleList();
  },
};
</script>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";
.custom-table-header > th {
  background: #dfdfdf !important;
}

.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
  color: #32383d;
}
.el-table .cell {
  color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}
.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
  border: 1px solid #acb5bd;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
}
::v-deep .el-input-number__decrease {
  display: none;
}
::v-deep .el-input-number__increase {
  display: none;
}
</style>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";
</style>
<style scoped>
</style>
